// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d3f4d00d","703":"a48b1806"}[chunkId] + ".chunk.js";
};